export const GET_HALLS = "GET_HALLS";
export const FETCH_HALLS = "FETCH_HALLS";
export const SET_HALLS = "SET_HALLS";
